import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface ICreateAPIKey {
  allowedPayrolls: string[]
  allowedRol: string
  name: string
  expiresAt: Date
}

/* convertir array a string */
export async function convertArrayToString(array: any) {
  return array.length === 0 ? '' : "'" + array.join("','") + "'"
}

export async function getAPIKeys(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // order by
  let orderBy = {}
  dataOrder !== ''
    ? (orderBy = { by: dataOrder[1], sense: dataOrder[0] })
    : (orderBy = { by: 'name', sense: 'asc' })
  // result
  const response: any = await http.post('/auth/apikeys/list/', {
    offset,
    limit: perPage,
    modifiers: {
      order: orderBy,
      where: { params: ['name'], like: search }
    }
  })
  return response.data
}

/* Consultas generales */
export async function getPayroll() {
  const data = await getData<any>({
    tables: ['pg_payrolls'],
    fields: [
      'payrolls.code as id',
      "CONCAT(payrolls.code,'-',payrolls.name) as name"
    ]
  })
  return data[0].results
}

export async function getWorkspace(
  workspace: string | undefined
): Promise<any[]> {
  if (!workspace) return []
  const response: any = await http.get(`auth/workspaces/${workspace}`)
  return response.data.assignedRoles
}

/* Reportes */
export async function createApiKeyManagement(
  data: ICreateAPIKey
): Promise<string> {
  const response: any = await http.post('/auth/apikeys ', {
    allowedPayrolls: data.allowedPayrolls,
    allowedRol: data.allowedRol,
    name: data.name,
    expiresAt: data.expiresAt
  })
  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function stateApiKey(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(`auth/apikeys/${id}/enable/`, {
    enable
  })
  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteApiKey(id: string): Promise<boolean> {
  const response: any = await http.delete('auth/apikeys/' + id)
  if (response?.data?.data?.error) {
    return false
  }
  return true
}
